// Filter Actions
export const ALL_VEHICLES_CHANGE_SEARCH = "ALL_VEHICLES_CHANGE_SEARCH"
export const ALL_VEHICLES_CHANGE_PAGE = "ALL_VEHICLES_CHANGE_PAGE"
export const TOGGLE_BULK_UPDATE_MODAL = "TOGGLE_BULK_UPDATE_MODAL"
export const TOGGLE_VEHICLE_MODAL = "TOGGLE_VEHICLE_MODAL"
export const UPDATE_SELECTED_VEHICLE = "UPDATE_SELECTED_VEHICLE"
export const ALL_VEHICLES_TOGGLE_NODE = "ALL_VEHICLES_TOGGLE_NODE"
export const ALL_VEHICLES_CHANGE_LIST = "ALL_VEHICLES_CHANGE_LIST"
export const UPDATE_PAYMENTS = "UPDATE_PAYMENTS"
export const TOGGLE_VEHICLE_OPEN = "TOGGLE_VEHICLE_OPEN"
export const CHANGE_TAB = "CHANGE_TAB"
export type AllVehiclesActions =
  | {
      type: "ALL_VEHICLES_CHANGE_SEARCH"
      payload: string
    }
  | {
      type: "ALL_VEHICLES_CHANGE_PAGE"
      payload: number
    }
  | {
      type: "TOGGLE_BULK_UPDATE_MODAL"
    }
  | {
      type: "UPDATE_SELECTED_VEHICLE"
      payload: any
    }
  | {
      type: "TOGGLE_VEHICLE_MODAL"
      payload: any
    }
  | {
      type: "ALL_VEHICLES_TOGGLE_NODE"
      path: string
      payload: any
    }
  | {
      type: "ALL_VEHICLES_CHANGE_LIST"
      payload: any
    }
  | {
      type: "UPDATE_PAYMENTS"
      payload: any
    }
  | {
      type: "TOGGLE_VEHICLE_OPEN"
      payload: number
    }
  | {
      type: "CHANGE_TAB"
      payload: string
    }
